var map = {
	"./de-DE.json": [
		2122,
		11
	],
	"./en-US.json": [
		2123,
		12
	],
	"./es-ES.json": [
		2124,
		13
	],
	"./fr-FR.json": [
		2125,
		14
	],
	"./it-IT.json": [
		2126,
		15
	],
	"./pt-BR.json": [
		2127,
		16
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1855;
module.exports = webpackAsyncContext;